import { gql, useMutation, MutationHookOptions } from "@apollo/client"

const APPROVE_TERMIANATION = gql`
  mutation ApproveTermination($terminationId: ID!) {
    approveTermination(input: { terminationId: $terminationId }) {
      errors
    }
  }
`

export const useApproveTermination = (options?: MutationHookOptions) =>
  useMutation(APPROVE_TERMIANATION, options)
